export default "__VITE_ASSET__X$BpN$Oe__"